import { render, staticRenderFns } from "./request-filter.vue?vue&type=template&id=827dd3a8"
import script from "./request-filter.vue?vue&type=script&lang=js"
export * from "./request-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports